import UserError from './UserError.js'

export class CheckGigyaUserExistsUserError extends UserError {}
